<template>
  <v-row class="py-2">
    <template v-for="(tile, index) in tilesData">
    <v-col 
      cols="12"
      sm="6"
      :key="index"
      v-if="tile.access"
      :lg= "userAccess.haveServiceRole && !userAccess.haveMarketingRole? '4' : '3'"
      class="card-info"
      :class="userAccess.haveServiceRole && !userAccess.haveMarketingRole && (tile.label=='Lifetime Value' || tile.label=='Number of Orders')? 'order-1':''"

      
    >
      <div >
        <v-card
          elevation="0"
          height="32"
          width="32"
          class="d-flex justify-center align-center mt-3 ml-1"
          :color="tile.iconColor"
        >
          <v-icon size="24" dark>
            mdi-{{ tile.mdiIcon }}
          </v-icon>
        </v-card>
        <v-card
          class="d-flex justify-top align-left flex-column pb-3 pt-7 px-1 mt-1"
          elevation="1"
          :height="144"
        >
          <h5
            :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
            class="text-center font-weight-medium "
          >
          <span class="primary--font">
            {{ tile.label }}
          </span>
          </h5>
          <v-skeleton-loader
            v-if="tile.loader"
            class="mx-auto"
            max-width="200"
            type="card-avatar"
          />
          <div
            v-else
            class="headline w-100 text-center font-weight-600 mt-3"
          > 
            <span class="secondary--font font-weight-600" v-if="tile.dataFormat === 'currency'">
              <v-tooltip
                top
                color="rgba(0, 0, 0, 0.9)"
              >
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                  >
                  {{ tile.value | numberStatFormat('$')}}
                  </span>
                </template>
                <span>{{ tile.value }}</span>
              </v-tooltip>
            </span>
            <span v-else>
              <span :class="tile.value ==='--' ? 'secondary--font' : ''" v-if="tile.value === '--'">{{ tile.value }}</span>
              <v-tooltip
                v-else
                top
                color="rgba(0, 0, 0, 0.9)"
              >
                <template v-slot:activator="{ on }">
                  <a
                    v-if="tile.link"
                    v-track="'show-order-details'"
                    @click="openLink(tile.label)"
                    class="text-decoration-none secondary--font font-weight-600 "
                    v-on="on"
                  >
                    {{ tile.value | numberStatFormat}}
                  </a>
                  <span v-else v-on="on" class="secondary--font font-weight-600 ">
                    {{ tile.value | numberStatFormat}}
                  </span>
                </template>
                <span>{{ tile.value }}</span>
              </v-tooltip>
            </span>
            <v-card-subtitle v-if="tile.subLabel" class="pa-0">
              {{ tile.subLabel }}
              <span v-if="tile.subValue === '--'">{{ tile.subValue }}</span>
              <span v-else>
                <span v-if="tile.subDataFormat === 'currency'">
                  <v-tooltip
                    top
                    color="rgba(0, 0, 0, 0.9)"
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                      >
                      {{ tile.subValue | numberStatFormat('$')}}
                      </span>
                    </template>
                    <span>{{ tile.subValue }}</span>
                  </v-tooltip>
                </span>
                <span v-else>
                  <v-tooltip
                    top
                    color="rgba(0, 0, 0, 0.9)"
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                      >
                      {{ tile.subValue | numberStatFormat}}
                      </span>
                    </template>
                    <span>{{ tile.subValue }}</span>
                  </v-tooltip>
                </span>
              </span>
            </v-card-subtitle>
          </div>
        </v-card>
      </div>
    </v-col>
  </template>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex"
export default {
    name: "dashboard-tiles",
    props: {
      tilesData: [Object],
      contactInfo: [Object],
    },
    data() {
        return {
        };
    },
    computed: {
    ...mapGetters({
      currentAccount: 'auth/account.current',
       userAccess : 'auth/userAccess'
    }),
  },
    methods: {
      openLink (label) {
        if (label === 'Number of Orders') {
          let query = {}
          if (process.env.VUE_APP_PRODUCT === 'Marketing') {
            if (this.$route.params.listId) {
              this.$router.push({
                name: 'list-contact-orders',
                params: { contactId: this.contactInfo.id, listId: this.$route.params.listId },
                query: query
              })
            } else {
              this.$router.push({ name: 'contact-orders', query: query })
            }
          } else {
            query.email = this.contactInfo.email
            this.$router.push({ name: 'contact-orders', query: query })
          }
        }
      },
    },
};
</script>
<style lang="scss" scoped>
.card-info {
  position: relative;
  .elevation-0 {
    left: 6px;
    height: 37px;
    position: absolute;
    width: 37px;
    z-index: 2;
    top: 3px;
  }
}
</style>